module.exports = __webpack_public_path__ + "static/scale-model-of-connect-crimson-in-tuscaloosa-alabama-86c73e4ca32a6a97e633a5db7394982e.png";